module.exports = __webpack_public_path__ + "img/icon-server.fb10baf9.png";